import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles(() => ({
  additionalContainerWrapper: {
    margin: 20,
  },
}));
